<template>
    <v-layout align-baseline>
        <template v-if="item.isHidden">
            <v-icon small color="grey-d" class="mr-8">mdi-eye-off-outline</v-icon>
        </template>
        <template v-else-if="item.isSecret">
            <v-icon small color="grey-d" class="mr-8">mdi-lock-outline</v-icon>
        </template>
        <template v-if="item.isHidden && !isUserAuthorized">
            <span class="grey-9--text"> 블라인드된 글입니다. </span>
        </template>
        <template v-else-if="item.isSecret && !isUserAuthorized">
            <span class="grey-9--text"> 비밀글입니다. </span>
        </template>
        <template v-else> {{ item.subject || "-" }}</template>
    </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { initExpoInquiry } from "@/assets/variables";

export default {
    props: {
        item: { type: Object, default: initExpoInquiry },
    },
    computed: {
        ...mapGetters(["_user", "doesUserHaveConsoleScope"]),
        isUserHost() {
            return this._user == this.item._host;
        },
        isUserItem() {
            return this._user == this.item._user;
        },
        isUserAuthorized() {
            return this.isUserItem || this.isUserHost || this.doesUserHaveConsoleScope;
        },
    },
};
</script>

<style>
</style>